import { GameTeams } from "common";
import Link from "next/link";
import React from "react";
import TeamLogo from "@/components/team/logo";

/**
 * Displays a versus between two teams.
 */
export default function GameTableVersus({
  teams,
  slug,
}: {
  teams: GameTeams;
  slug?: string;
}) {
  const content = (
    <div className="flex items-center gap-1">
      <div className="text-title-sm-medium uppercase w-7 flex justify-end">
        {teams.away.abbreviation}
      </div>
      <div className="px-2">
        <TeamLogo team={teams.away} size="xs" />
      </div>
      <div className="w-4">@</div>
      <div className="px-2">
        <TeamLogo team={teams.home} size="xs" />
      </div>
      <div className="text-title-sm-medium uppercase w-7 flex justify-start">
        {teams.home.abbreviation}
      </div>
    </div>
  );

  return slug ? (
    <Link href={slug} scroll={false}>
      {content}
    </Link>
  ) : (
    content
  );
}
